import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const NotFound = () => (
  <React.Fragment>
    <Helmet defer={false}>
      <title>Page Not Found | Avani Cimcon</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>

    <main className="container" style={{ padding: "6rem 1rem", textAlign: "center" }}>
      <p className="section-eyebrow">Error 404</p>
      <h1>Page not found</h1>
      <p style={{ maxWidth: "540px", margin: "1rem auto 2rem" }}>
        The page you are looking for does not exist or may have moved. Try one of these instead:
      </p>
      <ul style={{ listStyle: "none", padding: 0 }}>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/it-consulting-services">Services</Link></li>
        <li><Link to="/enterprise-ai">Enterprise AI</Link></li>
        <li><Link to="/blog">Insights &amp; Perspectives</Link></li>
        <li><Link to="/contact-us">Contact Us</Link></li>
      </ul>
    </main>
  </React.Fragment>
);

export default NotFound;
